import { render, staticRenderFns } from "./blacklistDisposal.vue?vue&type=template&id=4a5a9624&scoped=true"
import script from "./blacklistDisposal.vue?vue&type=script&lang=js"
export * from "./blacklistDisposal.vue?vue&type=script&lang=js"
import style0 from "./blacklistDisposal.vue?vue&type=style&index=0&id=4a5a9624&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a9624",
  null
  
)

export default component.exports